import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TSetPostPreviewAttribute, ESetPostPreviewAttributeActionType, ISetPostPreviewAttribute } from './types';
import { IPostPreviewAttributes } from '../../../types/postPreview';

export const setPostPreviewAttribute: <P extends keyof IPostPreviewAttributes>(
  data: ISetPostPreviewAttribute<P>,
) => TSetPostPreviewAttribute = actionGenerator<ESetPostPreviewAttributeActionType.Set, ISetPostPreviewAttribute>(
  ESetPostPreviewAttributeActionType.Set,
);
